"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
const React = require("react");
const mobx_react_1 = require("mobx-react");
const react_router_dom_1 = require("react-router-dom");
const classnames_1 = require("classnames");
class List extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        const { tagStore, type, codes, root, excludeGroupCodes, className } = this.props;
        let { groups } = this.props;
        if (!tagStore) {
            return null;
        }
        if (!groups) {
            groups = tagStore.groups;
        }
        const tagGroups = [];
        for (const i in groups) {
            const key = parseInt(i, 10);
            if (typeof groups[key] === 'string') {
                const group = tagStore.getGroup(groups[key]);
                if (group) {
                    tagGroups.push(group);
                }
            }
            else {
                tagGroups.push(groups[key]);
            }
        }
        return (React.createElement("div", { className: classnames_1.default('tag-list', className) }, tagGroups.map((group, gi) => {
            return tagStore.getFilteredTags({
                group: group,
                type: type,
                codes: codes,
                excludeGroupCodes: excludeGroupCodes
            }).map((tag, ti) => {
                const query = tagStore.getQuery(tag.code);
                const extra = this.getExtra(tag, group);
                return (React.createElement("div", { key: `${gi}.${ti}`, className: this.getItemWrapperClass(tag, group, extra) },
                    React.createElement(react_router_dom_1.Link, { to: `${root}?q=${tag.code}`, title: this.getItemTitle(tag, group, extra), className: this.getItemClass(tag, group, extra) }, this.renderContent(tag, group, extra))));
            });
        })));
    }
    getExtra(tag, group) {
        return {};
    }
    getItemTitle(tag, group, extra) {
        return tag.label;
    }
    getItemClass(tag, group, extra) {
        return classnames_1.default('tag', 'tag-group', 'tag-group-' + group.color);
    }
    getItemWrapperClass(tag, group, extra) {
        return classnames_1.default('mx-0', 'tag-wrapper');
    }
    renderContent(tag, group, extra) {
        return (React.createElement(React.Fragment, null,
            React.createElement("i", { className: " mdi mdi-pound" }),
            tag.label));
    }
}
exports.List = List;
exports.default = mobx_react_1.inject('tagStore')(mobx_react_1.observer(List));
